import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Slack integration not working`}</h2>
    <p>{`See `}<a parentName="p" {...{
        "href": "/ibm-aiops-training/06-configure-aimanager/06-configure-aimanager-09"
      }}>{`here`}</a></p>
    <div style={{
      "pageBreakAfter": "always"
    }}></div>
    <h2>{`Check if data is flowing`}</h2>
    <h3>{`Check  Log injection with Browser`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to DemoUI`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select tab `}<inlineCode parentName="p">{`System`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`Flink Connectors`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`ELKInception3`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You should see values go up under `}<inlineCode parentName="p">{`Records Sent`}</inlineCode>{` when launching incident creation`}</p>
        <img parentName="li" {...{
          "src": "./../images/59_flink_01.png",
          "alt": "ibm"
        }}></img>
      </li>
    </ol>
    <h3>{`Check Log injection with CommandLine`}</h3>
    <p>{`To check if logs are being injected through the demo script:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Launch `}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`./tools/22_monitor_kafka.sh

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select option 5`}</p>
      </li>
    </ol>
    <p>{`You should see data coming in.`}</p>
    <h3>{`Check Events injection with CommandLine`}</h3>
    <p>{`To check if events are being injected through the demo script:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Launch `}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`./tools/22_monitor_kafka.sh
`}</code></pre>
      </li>
    </ol>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Select option 4`}</li>
    </ol>
    <p>{`You should see data coming in.`}</p>
    <h3>{`Check Alerts and/or Stories being generated with CommandLine`}</h3>
    <p>{`To check if stories are being generated:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Launch `}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`./tools/22_monitor_kafka.sh

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select option 2 or 3`}</p>
      </li>
    </ol>
    <p>{`You should see data being generated.`}</p>
    <h2>{`Monitor ElasticSearch Indexes with Browser`}</h2>
    <p>{`Run `}<inlineCode parentName="p">{`./tools/28_access_elastic.sh`}</inlineCode>{` in a separate terminal window.`}</p>
    <p>{`This allows you to access ElasticSearch and gives you:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`ES User`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ES Password`}</p>
        <img parentName="li" {...{
          "src": "./../images/es0.png",
          "alt": null
        }}></img>
      </li>
    </ul>
    <h3>{`Monitor ElasticSearch Indexes from Firefox`}</h3>
    <p>{`I use the `}<a href="https://addons.mozilla.org/en-US/firefox/addon/elasticvue/" target="_blank">{`Elasticvue`}</a>{` Firefox plugin.`}</p>
    <p>{`Follow these steps to connects from Elasticvue:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`Add Cluster`}</inlineCode>{` `}</p>
        <img parentName="li" {...{
          "src": "./../images/es1.png",
          "alt": null
        }}></img>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Put in the credentials and make sure you put `}<inlineCode parentName="p">{`https`}</inlineCode>{` and not `}<inlineCode parentName="p">{`http`}</inlineCode>{` in the URL`}</p>
        <img parentName="li" {...{
          "src": "./../images/es2.png",
          "alt": null
        }}></img>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Test Connection`}</inlineCode>{` - you will get an error`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Click on the `}<inlineCode parentName="p">{`https://localhost:9200`}</inlineCode>{` URL`}</p>
        <img parentName="li" {...{
          "src": "./../images/es3.png",
          "alt": null
        }}></img>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`This will open a new Tab, select `}<inlineCode parentName="p">{`Accept Risk and Continue`}</inlineCode>{` `}</p>
        <img parentName="li" {...{
          "src": "./../images/es4.png",
          "alt": null
        }}></img>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Cancel the login screen and go back to the previous tab`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Connect`}</inlineCode>{` `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You should now be connected to your CP4AIOPS ElasticSearch instance `}</p>
        <img parentName="li" {...{
          "src": "./../images/es5.png",
          "alt": null
        }}></img>
      </li>
    </ul>
    <h3>{`Check ElasticSearch Indexes with CommandLine`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Run `}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`./tools/28_access_elastic.sh
`}</code></pre>
        <p parentName="li">{`in a separate terminal window.`}</p>
        <p parentName="li">{`This allows you to access ElasticSearch.`}</p>
      </li>
    </ol>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Launch `}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`./tools/23_monitor_es.sh

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select option 5`}</p>
      </li>
    </ol>
    <p>{`You should see data coming in.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      